import React from 'react'
import css from './style.scss'
import store from 'utils/store'
import FBComponent from 'components/shared/facebook/fb_component';
import FacebookLogin from 'components/shared/facebook';
import api from './api'

import AuthInfo from 'components/auth/auth_info'

const UserMismatchError=(props)=>(
  <div className={css.connect_error}>
    <p>
      Seems like the Facebook account that you are currently logged in
      is already connected to another Stori account.<br/>
      Please go to <a rel="noopener noreferrer" target="_blank" href="https://facebook.com">facebook.com</a>,
      logout from your current Facebook user and sign in with the right user.<br/>
    </p>
  </div>
)

class FacebookConnect extends FBComponent{
  constructor(props){
    super(props)
    this.state={
      error:this.props.message || ""
    }
  }
  onResponse = (response) => {
    console.log("RESPONSE", response)
    let data={
      token:response.accessToken,
      firstName:response.first_name,
      lastName:response.last_name,
      email:response.email,
      avatar:response.picture && response.picture.data && response.picture.data.url,
      id:response.id
    }
    this.setState({facebookUser:data})
    api.addFacebook(data).then(response=>{
      //add user to store!
      store.dispatch({type:"UPDATE_USER", payload: response.data.user})
      store.dispatch({type:"ADD_TOAST", message: "Yess! Your facebook account is now connected to Stori."})
      setTimeout(()=>{
        this.props.onConnected()
      },200)
    }).catch(err=>{
      this.setState({error:err.response.data.error})
    })
  }
  onError = () => {
    this.setState({permissionError:true})
  }

    //send to server, to check if login/signup.
  render(){
    console.log("THIS:STATE:USER", this.state.facebookUser)
    return (
      <div className={css.connect_facebook}>
        <div className={css.container}>
          <h4>Connect with Facebook to continue</h4>
          <FacebookLogin
            authType="rerequest"
            responseHandler={this.onResponse}
            onPermissionError={this.onError}
            className={css.facebook_button}
            buttonText="Connect With Facebook"
          />
          {this.state.error==="USER_MISMATCH" && <UserMismatchError facebookUser={this.state.facebookUser}/>}
        </div>
        <AuthInfo/>
      </div>
    )
  }
}

export default FacebookConnect



// WEBPACK FOOTER //
// ./src/components/setup/facebook_connect.js